<template>
    <div class="report-container">
        <el-card class="box-cardss">
            <template #header>
                <div class="card-header">
                    <span>广告埋点数据</span>
                    <div class="header-controls" style="display: flex;">
                        <div style="margin-left: 50px;">
                            <el-input v-model="searchForm.customerType" placeholder="请输入客户项目名" clearable
                                style="width: 330px;"></el-input>
                        </div>

                        <div style="margin-left: 50px;">
                            <el-input v-model="searchForm.url" placeholder="请输入URL关键词" clearable
                                style="width: 330px;"></el-input>
                        </div>

                        <div style="margin-left: 50px;">    
                            <el-date-picker v-model="searchForm.submitTimeRange" type="daterange" range-separator="至"
                                start-placeholder="开始日期" end-placeholder="结束日期"
                                value-format="yyyy-MM-dd HH:mm:ss"></el-date-picker>
                        </div>

                        <div style="margin-left: 50px;">
                            <el-button type="primary" @click="handleSearch" :loading="loading">
                                <i class="el-icon-search"></i>搜索
                            </el-button>
                            <el-button @click="handleReset">
                                <i class="el-icon-refresh"></i>重置
                            </el-button>
                        </div>
                    </div>
                </div>
            </template>

            <el-alert v-if="error" :title="`加载失败: ${error}`" type="error" show-icon closable class="error-alert">
                <el-button type="text" @click="fetchData">重试</el-button>
            </el-alert>

            <el-table border :data="tableData" v-loading="loading" style="width: 100%" class="beautified-table"
                :header-cell-style="headerCellStyle" :cell-style="cellStyle" :row-class-name="tableRowClassName">
                <el-table-column type="index" label="序号" width="80" align="center" fixed="left">
                    <template slot-scope="scope">
                        <span class="index-number">{{ (pagination.current - 1) * pagination.size + scope.$index + 1
                        }}</span>
                    </template>
                </el-table-column>

                <el-table-column prop="customerType" label="客户类型" min-width="120" align="center">
                    <template slot-scope="scope">
                        <div class="customer-type">
                            <!-- <i class="el-icon-user customer-icon"></i> -->
                            <span>{{ scope.row.customerType || '-' }}</span>
                        </div>
                    </template>
                </el-table-column>

                <el-table-column prop="url" label="访问URL" min-width="200" show-overflow-tooltip>
                    <template slot-scope="scope">
                        <div class="url-cell">
                            <i class="el-icon-link url-icon"></i>
                            <span class="url-text">{{ scope.row.url }}</span>
                        </div>
                    </template>
                </el-table-column>

                <el-table-column prop="customerOptions" label="客户选项" min-width="180">
                    <template slot-scope="scope">
                        <div class="options-cell">
                            {{ formatCustomerOptions(scope.row.customerOptions) }}

                        </div>
                    </template>
                </el-table-column>

                <el-table-column prop="submitTime" label="提交时间" width="180" align="center">
                    <template slot-scope="scope">
                        <div class="time-cell">
                            <i class="el-icon-time time-icon"></i>
                            <span class="time-text">{{ formatTime(scope.row.submitTime) }}</span>
                        </div>
                    </template>
                </el-table-column>

                <el-table-column prop="stayTime" label="停留时间" width="130" align="center">
                    <template slot-scope="scope">
                        <el-tag :type="getStayTimeType(scope.row.stayTime)" effect="light" class="stay-time-tag">
                            <i class="el-icon-timer"></i>
                            {{ scope.row.stayTime }}秒
                        </el-tag>
                    </template>
                </el-table-column>

                <el-table-column label="操作" fixed="right" align="center">
                    <el-button size="mini" type="danger" plain @click="handleDelete(scope.row.id)"
                        class="action-btn delete-btn">
                        <i class="el-icon-delete"></i>
                        删除

                    </el-button>

                </el-table-column>
            </el-table>

            <!-- 分页 -->
            <div class="pagination-container mt-4">
                <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                    :current-page="pagination.current" :page-sizes="[10, 20, 50, 100]" :page-size="pagination.size"
                    layout="total, sizes, prev, pager, next, jumper" :total="pagination.total"
                    class="beautified-pagination"></el-pagination>
            </div>
        </el-card>
    </div>
</template>

<script>
import { getCustomerRecords, addCustomerRecord, updateCustomerRecord, deleteCustomerRecord } from '@/api/customer';

export default {
    name: 'CustomerRecords',
    data() {
        return {
            // 搜索表单
            searchForm: {
                customerType: '',
                url: '',
                submitTimeRange: []
            },

            // 表格数据
            tableData: [],
            loading: false,
            error: null,

            // 分页信息
            pagination: {
                current: 1,
                size: 10,
                total: 0
            },

            // 对话框相关
            dialogVisible: false,
            dialogTitle: '新增客户记录',
            submitting: false,
            isEdit: false,

            // 表单数据
            form: {
                id: null,
                customerType: '',
                url: '',
                customerOptions: '',
                submitTime: '',
                stayTime: 0
            },

            // 表单验证规则
            rules: {
                customerType: [
                    { required: true, message: '请输入客户类型', trigger: 'blur' },
                    { max: 50, message: '客户类型长度不能超过50个字符', trigger: 'blur' }
                ],
                url: [
                    { required: true, message: '请输入访问URL', trigger: 'blur' },
                    { max: 500, message: 'URL长度不能超过500个字符', trigger: 'blur' }
                ],
                submitTime: [
                    { required: true, message: '请选择提交时间', trigger: 'change' }
                ],
                stayTime: [
                    { required: true, message: '请输入停留时间', trigger: 'blur' },
                    { type: 'number', min: 0, message: '停留时间必须大于等于0', trigger: 'blur' }
                ]
            }
        };
    },

    mounted() {
        this.loadTableData();
    },

    methods: {
        // 表格行样式
        tableRowClassName({ rowIndex }) {
            return rowIndex % 2 === 1 ? 'even-row' : 'odd-row';
        },

        // 表头样式
        headerCellStyle() {
            return {
                background: '#f5f7fa',
                color: '#606266',
                fontWeight: '600',
                fontSize: '14px',
                borderBottom: '1px solid #e0e0e0',
                padding: '12px 8px'
            };
        },

        // 单元格样式
        cellStyle() {
            return {
                padding: '12px 8px',
                borderBottom: '1px solid #f0f0f0'
            };
        },

        // 加载表格数据
        async loadTableData() {
            this.loading = true;
            this.error = null;
            try {
                const params = {
                    pageNum: this.pagination.current,
                    pageSize: this.pagination.size,
                    customerType: this.searchForm.customerType,
                    url: this.searchForm.url
                };

                // 处理时间范围
                if (this.searchForm.submitTimeRange && this.searchForm.submitTimeRange.length === 2) {
                    params.submitTimeStart = this.searchForm.submitTimeRange[0];
                    params.submitTimeEnd = this.searchForm.submitTimeRange[1];
                }

                const response = await getCustomerRecords(params);
                console.log('API响应:', response);
                if (response.code === '0') {
                    this.tableData = response.data.records || [];
                    this.pagination.total = response.data.total || 0;
                } else {
                    this.$message.error(response.msg || '获取数据失败');
                }
            } catch (error) {
                console.error('加载数据失败:', error);
                this.error = error.message;
                this.$message.error('加载数据失败');
            } finally {
                this.loading = false;
            }
        },

        // 搜索
        handleSearch() {
            this.pagination.current = 1;
            this.loadTableData();
        },

        // 重置搜索条件
        handleReset() {
            this.searchForm = {
                customerType: '',
                url: '',
                submitTimeRange: []
            };
            this.pagination.current = 1;
            this.loadTableData();
        },

        // 新增记录
        handleAdd() {
            this.dialogTitle = '新增客户记录';
            this.isEdit = false;
            this.form = {
                id: null,
                customerType: '',
                url: '',
                customerOptions: '',
                submitTime: '',
                stayTime: 0
            };
            this.dialogVisible = true;
            this.$nextTick(() => {
                this.$refs.form && this.$refs.form.clearValidate();
            });
        },

        // 编辑记录
        handleEdit(row) {
            this.dialogTitle = '编辑客户记录';
            this.isEdit = true;
            this.form = {
                ...row,
                submitTime: this.formatTimeForEdit(row.submitTime)
            };
            this.dialogVisible = true;
            this.$nextTick(() => {
                this.$refs.form && this.$refs.form.clearValidate();
            });
        },

        // 提交表单
        handleSubmit() {
            this.$refs.form.validate(async (valid) => {
                if (valid) {
                    this.submitting = true;
                    try {
                        const formData = { ...this.form };

                        let response;
                        if (this.isEdit) {
                            response = await updateCustomerRecord(formData);
                        } else {
                            response = await addCustomerRecord(formData);
                        }

                        if (response.code === '200' || response.code === '0') {
                            this.$message.success(this.isEdit ? '更新成功' : '新增成功');
                            this.dialogVisible = false;
                            this.loadTableData();
                        } else {
                            this.$message.error(response.msg || response.message || '操作失败');
                        }
                    } catch (error) {
                        console.error('提交失败:', error);
                        this.$message.error('提交失败');
                    } finally {
                        this.submitting = false;
                    }
                }
            });
        },

        // 删除记录
        handleDelete(id) {
            this.$confirm('确定要删除这条记录吗?', '提示', {
                type: 'warning',
                confirmButtonText: '确定',
                cancelButtonText: '取消'
            }).then(async () => {
                try {
                    const response = await deleteCustomerRecord(id);
                    if (response.code === '200' || response.code === '0') {
                        this.$message.success('删除成功');
                        this.loadTableData();
                    } else {
                        this.$message.error(response.msg || response.message || '删除失败');
                    }
                } catch (error) {
                    console.error('删除失败:', error);
                    this.$message.error('删除失败');
                }
            }).catch(() => { });
        },

        // 导出数据
        handleExport() {
            this.$message.info('导出功能开发中...');
        },

        // 分页大小改变
        handleSizeChange(size) {
            this.pagination.size = size;
            this.pagination.current = 1;
            this.loadTableData();
        },

        // 当前页改变
        handleCurrentChange(current) {
            this.pagination.current = current;
            this.loadTableData();
        },

        // 格式化时间显示
        formatTime(timeObj) {
            if (!timeObj) return '-';

            // 如果是字符串格式的时间，直接返回
            if (typeof timeObj === 'string') {
                return timeObj;
            }

            // 处理嵌套的时间对象
            if (typeof timeObj === 'object') {
                const { year, monthValue, dayOfMonth, hour, minute, second } = timeObj;

                // 补零函数
                const padZero = (num) => num.toString().padStart(2, '0');

                return `${year}-${padZero(monthValue)}-${padZero(dayOfMonth)} ${padZero(hour)}:${padZero(minute)}:${padZero(second)}`;
            }

            return '-';
        },

        // 为编辑表单格式化时间
        formatTimeForEdit(timeObj) {
            if (!timeObj) return '';

            // 如果是字符串格式的时间，直接返回
            if (typeof timeObj === 'string') {
                return timeObj;
            }

            // 处理嵌套的时间对象
            if (typeof timeObj === 'object') {
                const { year, monthValue, dayOfMonth, hour, minute, second } = timeObj;

                // 补零函数
                const padZero = (num) => num.toString().padStart(2, '0');

                return `${year}-${padZero(monthValue)}-${padZero(dayOfMonth)} ${padZero(hour)}:${padZero(minute)}:${padZero(second)}`;
            }

            return '';
        },

        // 格式化客户选项
        formatCustomerOptions(options) {
            try {
                if (typeof options === 'string') {
                    const obj = JSON.parse(options);
                    return Object.entries(obj).map(([key, value]) => `${key}:${value}`).join(', ');
                }
                return options;
            } catch (error) {
                console.log('解析客户选项失败:', error);
                return options;
            }
        },

        // 根据停留时间获取标签类型
        getStayTimeType(stayTime) {
            if (stayTime < 30) return 'danger';
            if (stayTime < 60) return 'warning';
            if (stayTime < 180) return 'primary';
            return 'success';
        },

        // 重试加载数据
        fetchData() {
            this.loadTableData();
        }
    }
};
</script>

<style scoped>
/*  */
</style>


// WEBPACK FOOTER //
// src/components/kehu/CustomerRecords.vue